'use client';

import { useEntryIndex } from './useEntryIndex';
import React from 'react';
import { useEntryIndexQueryHandler } from './useEntryIndexQueryHandler';

/**
 * This component is responsible for triggering the query
 * when the entry index has changes and autoSubmit is enabled
 */
export default function EntryIndexAutoSubmit() {
  const { hasChanges, ready, triggerQuery } = useEntryIndexQueryHandler();
  const autoSubmit = useEntryIndex((s) => s.autoSubmit);
  const initialLoaded = useEntryIndex((s) => s.initialLoaded);

  const shouldAutoSubmit = ready && initialLoaded && autoSubmit && hasChanges;
  const shouldDoInitial = ready && !initialLoaded;

  React.useEffect(() => {
    if (!shouldAutoSubmit) return;
    // console.log('triggering auto query');
    return triggerQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldAutoSubmit]);

  React.useEffect(() => {
    if (!shouldDoInitial) return;
    // console.log('triggering initial query');
    return triggerQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldDoInitial]);

  return null;
}
